import { render } from "./WhiteBlock.vue?vue&type=template&id=972b261a&scoped=true"
const script = {}

import "./WhiteBlock.vue?vue&type=style&index=0&id=972b261a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972b261a"]])

export default __exports__